export default "__VITE_ASSET__DKRzQiep__"